import React, { useState } from 'react';
import PropTypes from 'prop-types';
import uniq from 'lodash/uniq';
import { v4 as uuidv4 } from 'uuid';

import { useDispatch, useSelector } from 'react-redux';
import { setHighlightedFeatures } from '../../../../redux/highlights/Actions';
import { openSiteCardCreator, toggleLandAssemblyFeaturesAsync } from '../../../../redux/land_assembly/Actions';
import { setAreaCriteria } from '../../../../redux/search_area/Actions';
import { showSecondaryPanel } from '../../../../redux/panel/Actions';
import { OWNERSHIP_REDUCER } from '../../../../redux/ReducerNames';
import { OWNERSHIP_SEARCH } from '../../../../redux/panel/PanelNames';

import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import MoreOptionsButton from '../common/MoreOptionsButton';

const useStyles = makeStyles((theme) => style(theme));

const propTypes = {

};

const defaultProps = {

};

function LandAssemblyActions () {
    const classes = useStyles();

    const dispatch = useDispatch();
    const dispatchClearHighlightedFeatures = () => dispatch(setHighlightedFeatures([]));
    const dispatchOpenSiteCardCreator = () => dispatch(openSiteCardCreator());
    const dispatchToggleLandAssemblyFeatures = (features) => dispatch(toggleLandAssemblyFeaturesAsync(features));
    const dispatchSetOwnershipCriteria = (criteria) => dispatch(setAreaCriteria(OWNERSHIP_REDUCER, criteria));
    const dispatchShowSecondaryPanel = (panel) => dispatch(showSecondaryPanel(panel)); 

    const features = useSelector(state => state.landAssembly.features);
    const featureIds = features.map(feature => feature.featureId);

    function createSiteCard () {
        dispatchOpenSiteCardCreator();
    }

    function clear () {
        // dispatchClearHighlightedFeatures();
        dispatchToggleLandAssemblyFeatures(features);
    }

    function openOwnershipSearch () {
        // Only works for hmlr which has ownership
        
        const proprietor_names = uniq(
            features
                .map(feature => feature.properties.proprietorship_name)
                .filter(name => Boolean(name))
        );

        // dispatchsetownershipcriteria
        // diaptch switch panel

        const criteria = {
            "id": "root",
            "type": "group",
            "conjunction": "and",
            "not": false,
            "children": [
                {
                    "id": uuidv4(),
                    "type": "rule",
                    "field": "proprietor_name",
                    "properties": {
                        "operator": "ilike",
                        "values": proprietor_names
                    }
                }
            ]
        };
        dispatchSetOwnershipCriteria(criteria);
        dispatchShowSecondaryPanel(OWNERSHIP_SEARCH);
    }

    // Temp commented while ownership under review
    const isMoreOptions = false;
    return (
        <Grid container spacing={2}>
            <Grid item xs={4}>
                <Button
                    variant="outlined"
                    size="large"
                    color="secondary"
                    fullWidth
                    onClick={clear}
                >
                    Clear
                </Button>
            </Grid>
            <Grid item xs={isMoreOptions ? 7 : 8}>
                <Button
                    variant="contained"
                    size="large"
                    color="secondary"
                    fullWidth
                    disabled={featureIds.length === 0}
                    onClick={createSiteCard}
                >
                    Create site card
                </Button>
            </Grid>
            {
                isMoreOptions &&
                <Grid item xs={1}>
                    <MoreOptionsButton>
                        {/* Disable this option if no owners */}
                        {/* Hide this tool if no access */}
                        <MenuItem onClick={openOwnershipSearch}>
                            {/* <ListItemIcon>
                                <EditIcon />
                            </ListItemIcon> */}
                            <ListItemText>
                                Search for more owners
                            </ListItemText>
                            <ListItemIcon>
                                <Tooltip 
                                    arrow 
                                    title="Open up the ownership search tool with the proprietor names automatically populated from the proprietors present in this land assembly"
                                    placement="right"
                                >
                                    <InfoOutlinedIcon />
                                </Tooltip>
                            </ListItemIcon>
                        </MenuItem>
                    </MoreOptionsButton>
                </Grid>
            }
        </Grid>
    )
}      

LandAssemblyActions.propTypes = propTypes;
LandAssemblyActions.defaultProps = defaultProps;

const style = theme => ({
    actionsRoot: {
        display: 'flex',
        '& > *': {
            flex: '1 1 0',
            '&:not(:last-child)': {
                marginRight: 12
            }
        }
    },
    moreActionsButton: {
        flexGrow: 0,
        padding: 10,
        minWidth: 'initial'
    }
});

export default LandAssemblyActions;